import React, { PropTypes } from "react";
import postscribe from "postscribe";

class NativeAd extends React.Component {

  trackingId() {
    if(process.env.REACT_APP_ENV === "production") {
      return "clothingsizer-20";
    }
    return "";
  }

  componentDidMount() {
    window.amzn_assoc_placement = "adunit0";
    window.amzn_assoc_tracking_id = this.trackingId();
    window.amzn_assoc_ad_mode = "search";
    window.amzn_assoc_ad_type = "smart";
    window.amzn_assoc_marketplace = "amazon";
    window.amzn_assoc_region = "US";
    window.amzn_assoc_title = `Shop ${this.props.brand.name} Products`;
    // The internal search phrases MUST be in single quotes NOT double quotes
    window.amzn_assoc_default_search_phrase = `'${this.props.brand.name}' Clothing`;
    window.amzn_assoc_default_category = "Baby";
    window.amzn_assoc_linkid = "a9c96e8dd75dba0e1a3010211a3eca33";
    window.amzn_assoc_default_browse_node = "165796011";
    window.amzn_assoc_search_bar = "false";

    postscribe("#amazon-ad", "<script src=\"//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US\"></script>");
  }

  render() {
    return (
      <div id="amazon-ad" className="text-center" style={{paddingTop: "1em"}} />
    );
  }
}

NativeAd.propTypes = {
  brand: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

export default NativeAd;



/** WEBPACK FOOTER **
 ** ./src/components/Amazon/NativeAd.js
 **/